import { useEffect, useRef } from 'react';
export const useEffectOnUpdate = (callback, deps) => {
    const first = useRef(true);
    useEffect(() => {
        if (first.current) {
            first.current = false;
        }
        else {
            return callback();
        }
    }, deps);
};
/*
const useUpdateEffect: typeof useEffect = (effect, deps) => {
    const isFirstMount = useFirstMountState();
  
    useEffect(() => {
      if (!isFirstMount) {
        return effect();
      }
    }, deps);
  };
  
  export default useUpdateEffect;



  export function useFirstMountState(): boolean {
  const isFirst = useRef(true);

  if (isFirst.current) {
    isFirst.current = false;

    return true;
  }

  return isFirst.current;
}
*/ 
